import { FC } from "react";
import classNames from "classnames";
import { IBaseField } from ".";
import { FieldControl } from "src/UI";
import st from "./Control.module.scss";

interface ITextProps extends IBaseField {
	autoFocus?: boolean;
	id?: string;
};

/**
 * Текстовое поле
 */
const Text: FC<ITextProps> = ( props ) => {

	const { name, title, isRequired = false, disabled = false, placeholder,
		value, touched = false, error, onChange, onBlur, size = "std", autoFocus = false, id
	} = props;

	const inputClasses = classNames( st.input, st[size], {
		[st.inValidate]: ( touched && error )
	});

	return (
		<FieldControl 
			name={name} 
			title={title} 
			isRequired={isRequired}
			isInvalid={!!touched && !!error}
			errorMsg={error}
			isTouched={touched}
		>
			<input
				id={id}
				type='text'
				name={name}
				value={value ?? ""}
				onChange={onChange}
				onBlur={onBlur}
				placeholder={placeholder}
				className={inputClasses}
				readOnly={disabled}
				disabled={disabled}
				autoFocus={autoFocus}
			/>
		</FieldControl>
	);
};

export default Text;
